<template>
    <div class="bonusomat-odometer">
        <div
            v-for="(val, index) in odometerDigitsValues"
            :key="'odometerDigitsValues-' + index"
            ref="odometerDigitsRefs"
        ></div>
        <template v-if="isWidget">
            <span class="bonusomat-odometer__letter-odometer odometer-auto-theme">
                <span class="bonusomat-odometer__odometer-inside">
                    <span class="odometer-digit">
                        <span class="odometer-digit-inner">
                            <span class="odometer-ribbon">
                                <span class="odometer-ribbon-inner">
                                    <span class="bonusomat-odometer__letter">
                                        <span class="odometer-value odometer-value--unit">K</span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>
                </span>
            </span>
            <span class="bonusomat-odometer__letter-odometer odometer-auto-theme">
                <span class="bonusomat-odometer__odometer-inside">
                    <span class="odometer-digit">
                        <span class="odometer-digit-inner">
                            <span class="odometer-ribbon">
                                <span class="odometer-ribbon-inner">
                                    <span class="bonusomat-odometer__letter">
                                        <span class="odometer-value odometer-value--unit">č</span>
                                    </span>
                                </span>
                            </span>
                        </span>
                    </span>
                </span>
            </span>
        </template>
        <div class="bonusomat-odometer__unit" v-else-if="unit">{{ unit }}</div>
    </div>
</template>

<script lang="ts" setup>
import { computed, onMounted, ref, watch } from "vue";
import Odometer from "odometer";

const props = defineProps<{
    counterValue: number;
    numeralCount: number; // number of numerals we want to show
    unit?: string;
    isWidget?: boolean;
}>();

const odometerDigitsRefs = ref<HTMLDivElement[]>([]);

// Parses number to array of each numeral, e.g. number "250731" when using numeralCount = 7 => [0, 2, 5, 0, 7, 3, 1]
const parseNumberToNumeralArray = (val: number): number[] => {
    const numeralArray: number[] = [];
    let currentVal = val;

    for (let i = props.numeralCount - 1; i >= 0; i--) {
        const power = Math.pow(10, i);
        if (currentVal >= power) {
            numeralArray.push(Math.floor(currentVal / power));
            currentVal = currentVal % power;
        } else {
            numeralArray.push(0);
        }
    }

    return numeralArray;
};

const odometerDigitsValues = computed(() => parseNumberToNumeralArray(props.counterValue));

watch(odometerDigitsValues, (newValue) => {
    for (let i = 0; i < odometerDigitsValues.value.length; i++) {
        odometerDigitsRefs.value[i].innerHTML = newValue[i].toString();
    }
});

onMounted(() => {
    for (let i = 0; i < odometerDigitsValues.value.length; i++) {
        const odometer = new Odometer({
            el: odometerDigitsRefs.value[i],
            value: "0",
        });
        odometer.render();

        setTimeout(() => {
            odometerDigitsRefs.value[i].innerHTML = odometerDigitsValues.value[i].toString();
        }, (odometerDigitsValues.value.length - i) * 300);
    }
});
</script>
